$(function() {
    var $body = $('body');
    var $header = $('.site-header');
    var $infoBanner = $('.site-banner');
    var $handheldMenuOverlay = $('.handheld-menu__overlay');
    var $handheldHeaderNavWrapper = $('.handheld-header__nav-wrapper');

    var refreshHeaderHeight = function() {
        var headerHeight = $header.outerHeight();
        var infoBannerHeight = $infoBanner.outerHeight();
        var paddingTop = headerHeight + infoBannerHeight;
        
        if ($infoBanner.length) {
            $header.css('top', infoBannerHeight);
            $body.css('padding-top', paddingTop);
            $handheldHeaderNavWrapper.css({
                // 'top': 99,
                'top': headerHeight,
                // 'height': 'calc(100vh - ' + paddingTop + 'px)'
                'height': 'calc(100vh - ' + headerHeight + 'px)'
            });
            $handheldMenuOverlay.css({
                // 'top': paddingTop,
                'top': headerHeight,
                // 'height': 'calc(100vh - ' + paddingTop + 'px)'
                'height': 'calc(100vh - ' + headerHeight + 'px)'
            });
        } 
        else {
            if(window.matchMedia("(max-width: 1024px)").matches) {
                // $('.homepage-header').css('margin-top', 99);
                // $('.page-header').css('margin-top', 99);
                $('.homepage-header').css('margin-top', headerHeight);
                $('.page-header').css('margin-top', headerHeight);
            }
        }        
    }

    refreshHeaderHeight();
    $(window).on('load', refreshHeaderHeight);
    $(window).on('resize', refreshHeaderHeight);
    $(window).on('header:stateChange', refreshHeaderHeight);
});